import Button from "@/common/components/Button";
import Modal from "@/common/components/Modal";
import { ModalMessageSimple } from "@/common/components/ModalMessageSimple";
import { useCurrentUser } from "@/common/hooks/useCurrentUser";
import { FormTransformers } from "@/common/utils/formTransformers";
import { useDeleteCompanyBranchUserAccesses } from "@/features/companyBranches/hooks/useDeleteCompanyBranchUserAccesses";
import { ClientUserBranchAccess } from "@/features/companyBranches/types/clientUserBranchAccess.type";
import { useQueryClient } from "@tanstack/react-query";
import { TrashIcon } from "lucide-react";
import { useState } from "react";

interface CompanyBranchUserAccessesUpdateProps {
  userBranchAccess: ClientUserBranchAccess;
}

const CompanyBranchUserAccessesDelete = ({ userBranchAccess }: CompanyBranchUserAccessesUpdateProps) => {
  const queryClient = useQueryClient();

  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState<string[] | boolean>(false);

  const { data: currentUser } = useCurrentUser({});

  const {
    mutate: deleteCompanyBranchUserAccesses,
    isPending: deleteCompanyBranchUserAccessesIsPending,
  } = useDeleteCompanyBranchUserAccesses({
    userBranchAccess,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['clientUserBranchAccesses', userBranchAccess.branch?.id] });
      setIsOpen(false);
    },
    onError: (error) => {
      FormTransformers.errorsTransformer({
        setMessages,
      })(error);
    },
  });

  return (
    <>
      <Modal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        Trigger={(
          <Button
            variant="link-white"
            operationKlassToCheckPermission="Client::CompanyBranches::UpdateUserAccesses"
            disabled={currentUser?.id === userBranchAccess.user.id}
            tooltipMessage={currentUser?.id === userBranchAccess.user.id ? 'Não é possível remover o acesso do seu próprio usuário' : undefined}
          >
            <TrashIcon strokeWidth={1.5} className="text-warning" />
          </Button>
        )}
        bodyClassName='max-h-[calc(90vh-72px-48px)] overflow-auto'
        title="Você tem certeza?"
        subtitle="Essa ação não é reversível."
        titleClass="text-2xl"
        subtitleClassName="text-base mt-1"
        useCancellableFooter
        cancelButtonClassName="bg-white-100 rounded-es-lg"
        confirmButtonClassName="rounded-ee-lg"
        confirmButtonIsLoading={deleteCompanyBranchUserAccessesIsPending}
        disabled={deleteCompanyBranchUserAccessesIsPending}
        showClose={false}
        onConfirm={() => deleteCompanyBranchUserAccesses()}
      />

      <ModalMessageSimple
        messages={messages}
        setMessages={setMessages}
        isError
      />
    </>
  )
}

export default CompanyBranchUserAccessesDelete;
